import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import store from '@/store'
import Tabs from '../views/Tabs.vue'
import { DxpLogin, useAuthStore } from '@hotwax/dxp-components';
import { loader } from '@/user-utils';

const authGuard = async (to: any, from: any, next: any) => {
  const authStore = useAuthStore()
  if (!authStore.isAuthenticated || !store.getters['user/isAuthenticated']) {
    await loader.present('Authenticating')
    // TODO use authenticate() when support is there
    const redirectUrl = window.location.origin + '/login'
    window.location.href = `${process.env.VUE_APP_LOGIN_URL}?redirectUrl=${redirectUrl}`
    loader.dismiss()
  }
  next()
};

const loginGuard = (to: any, from: any, next: any) => {
  const authStore = useAuthStore()
  if (authStore.isAuthenticated && !to.query?.token && !to.query?.oms) {
    next('/')
  }
  next();
};

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/tabs/open'
  },
  {
    path: '/tabs/',
    component: Tabs,
    children: [
      {
        path: '',
        redirect: '/tabs/open'
      },
      {
        path: 'open',
        component: () => import('@/views/StockMove.vue'),
        beforeEnter: authGuard
      },
      {
        path: 'in-progress',
        component: () => import('@/views/InProgress.vue'),
        beforeEnter: authGuard
      },
      {
        path: 'settings',
        component: () => import('@/views/Settings.vue'),
        beforeEnter: authGuard
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: DxpLogin,
    beforeEnter: loginGuard
  },
  {
    path: "/item/:itemType/:workEffortType/:taskType",
    name: "ItemDetail",
    component: () => import("@/views/ItemDetail.vue"),
    props: true
  },
  {
    path: "/begin-putaway/:itemType/:workEffortType",
    name: "BeginPutAway",
    component: () => import("@/views/BeginPutAway.vue"),
    beforeEnter: authGuard,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
